var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important",
            height: "110px"
          }
        },
        [
          _c("div", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("APPLICATION MANAGER")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex m__t--42" },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "div",
                {
                  key: tab.id,
                  staticClass: "tab-experience-manager m__r--35",
                  class: {
                    "tab-experience-manager-active": _vm.tabSelected === tab.id
                  },
                  on: {
                    click: function($event) {
                      _vm.tabSelected = tab.id
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(tab.text) + "\n      ")]
              )
            })
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _vm.tabSelected === "apps" ? _c("j-application-app-tab") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "group" ? _c("j-application-group-tab") : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0fb6684", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0fb6684","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/jApplicationManager.vue
// module id = null
// module chunks = 